var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCupBar = function SvgCupBar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M1.313 1.313a.437.437 0 1 0 0 .875h.437v6.124a1.75 1.75 0 0 0 1.75 1.75h.706l-.684 2.05a.438.438 0 1 0 .83.276l.193-.575h4.91l.193.575a.438.438 0 0 0 .83-.276l-.683-2.05h.705a1.75 1.75 0 0 0 1.75-1.75V2.189h.438a.438.438 0 0 0 0-.876zm3.523 9.625.292-.876h3.745l.291.876zm4.352-7a.437.437 0 1 0-.876 0v3.5a.437.437 0 1 0 .876 0zM7.438 5.25a.437.437 0 1 0-.875 0v2.188a.437.437 0 1 0 .875 0zm-1.75 1.313a.437.437 0 1 0-.875 0v.875a.437.437 0 1 0 .875 0z",
    clipRule: "evenodd"
  })));
};
export default SvgCupBar;